import EventEmitter from 'eventemitter3'

const eventEmitter = new EventEmitter()

// 扩展一个异步方法
eventEmitter.emitAsync = async(eventName, ...args) => {
    // 获取到所有的注册事件

    const createPromise = () => {
        const source = {}
        source.promise = new Promise((resolve, reject) => {
            source.resolve = resolve
            source.reject = reject
        })
        return source
    }
    const promiseQueue = []
    const randomString = `${Math.random()}`.replace(/\./, '')

    const allEvents = eventEmitter.listeners(eventName)
        // 注销所有的原监听事件
        // eventEmitter.removeAllListeners(eventName)

    // 遍历整个列表重新绑定
    allEvents.forEach(call => {
        const newCall = new Proxy(call, {
            async apply(target, context, args) {
                const promiseInstance = createPromise()
                promiseQueue.push(promiseInstance.promise)
                try {
                    await target.apply(context, args)
                    setTimeout(promiseInstance.resolve, 20)
                } catch (ex) {
                    setTimeout(() => {
                        promiseInstance.reject(ex)
                    }, 20)
                }
            }
        })
        eventEmitter.once(`${eventName}.${randomString}`, newCall)
    })
    eventEmitter.emit(`${eventName}.${randomString}`, ...args)
    return Promise.all(promiseQueue)
}

export default eventEmitter
